import { useOfferFiltersState } from "../context/OfferFiltersContext";
import AccordionChevronIcon from "./AccordionChevronIcon";
import FilterBadge from "./FilterBadge";
import PriceRangePicker from "./PriceRangePicker";
import StaticButtonGroup from "./StaticButtonGroup";
import clsx from "clsx";
import React from "react";
function FilterItem({ filter, }) {
    if (filter.type === "range") {
        return <PriceRangePicker filter={filter}/>;
    }
    return <StaticButtonGroup filter={filter}/>;
}
export default function StaticFilterSection({ label, filters, isOpen, onToggle, }) {
    const { committedState } = useOfferFiltersState();
    const count = filters.filter((f) => {
        const value = committedState[f.id];
        return value !== undefined && value !== "";
    }).length;
    return (<div>
      <button type="button" onClick={onToggle} className="w-full flex items-center justify-between py-[17px] text-left">
        <span className="flex items-center gap-2">
          {label}
          {count > 0 && <FilterBadge count={count}/>}
        </span>
        <AccordionChevronIcon className={clsx("size-6", isOpen && "rotate-180")}/>
      </button>
      {isOpen && (<div className="pb-4 flex flex-col gap-2">
          {filters.map((filter) => (<div key={filter.id}>
              <FilterItem filter={filter}/>
            </div>))}
        </div>)}
    </div>);
}
